import React, { useEffect, useState } from "react";
import ReportOptions from "../ReportOptions";
import { Button } from "bootstrap";
import { useNavigate } from "react-router-dom";
import { proxy } from '../../process/api';
import DynamicDTFloat from "../DynamicDTFloat";
import DropDownControl from "../DropDownControl";
import BrandedLoader from "../BrandedLoader";
import { nw01_report_json_format, generateExcel, getHeaderColNames, excelColorCodes, transformNavDataForLabels, goFullScreen } from "../../utils";
import ProcessLoader from "../ProcessLoader";


const HY04 = () => {


    const navigate = useNavigate();

    const div_data = JSON.parse(localStorage.getItem('div_data'));
    const year_data = JSON.parse(localStorage.getItem('year_data'));
    const month_data = JSON.parse(localStorage.getItem('month_data'));
    const depo_data = JSON.parse(localStorage.getItem('depo_data'));
    const today = new Date();

    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();

    const seleted_div_value = localStorage.getItem('selected_div');
    const [showOptions, setShowOptions] = useState(true);
    const [reportGenData, setreportGenData] = useState({});
    const [SelectedDiv, setSelectedDIV] = useState(seleted_div_value);
    const [SelectedYear, setSelectedYear] = useState(year_data.data[0].value);
    const [SelectedDate, setSelectedDate] = useState(`${day}/${month}/${year}`);
    const [productListItems, setProductListItems] = useState([]);
     const [sampleListItems, setSampleListItems] = useState([]);
    const [productlistLoading, setProductlistLoading] = useState(true);
    const [SelectedProductCode, setSelectedProductCode] = useState(0);
    const [showProcessLoader, setShowProcessLoader] = useState(false);
    const [pageTitle, setPageTitle] = useState('');
    const [ReportType, setReportType] = useState(1);
    const [SelectedDepo, setSelectedDepo] = useState(0);
    const [OptnValue, setOptnValue] = useState(1);

     const getSampleProducts = async (divID) => {
    
            try {
                const response = await proxy(`/api/mis/sampleproductlist/${divID}`, {}, "get");
                setSampleListItems(response);
                setProductlistLoading(false);
    
            } catch (error) {
                console.error("Error fetching sample products:", error);
                return [];// Return an empty array or handle the error as needed
            }
        };
    



    const handleExportSheet = async () => {

        var reportJson = {};
        reportJson.fileName = reportGenData.title + ".xlsx";
        reportJson.title = reportGenData.title;
        reportJson.author = "Aristo Pharma";
        reportJson.sheets = [
            {
                name: "Sheet 1",
                data: []
            }
        ]

        const columns = Object.keys(reportGenData.data[0]).filter(key => key !== 'color');
        const headerFormatted = columns.map(key => getHeaderColNames(key));

        reportJson.sheets[0].data.push({
            backgroundColor: "#0043a9",
            fontColor: "#FFFFFF",
            fontSize: 13,
            bold: true,
            values: headerFormatted
        });

        const backgroundColors = excelColorCodes;

        reportGenData.data.forEach(item => {
            const row = {
                backgroundColor: backgroundColors[item.color] || "", // Default to white if undefined
                fontColor: item.color === 2 ? "#333333" : "#333333",
                fontSize: 12,
                bold: false,
                values: columns.map(col => item[col])
            };
            reportJson.sheets[0].data.push(row);
        });

        generateExcel(reportJson, 20, 18).catch(console.error);

    }
    const handleReportGen = async () => {

        setShowProcessLoader(true);
        document.getElementById('btnReportGen').innerHTML = "PROCESSING...";

        const dateParts = document.getElementById('SelectedDate').value.split("/");
        const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;

        const payload = {

            "report_type": parseInt(ReportType),
            "div_code": SelectedDiv,
            "code": SelectedProductCode,
            "depo_code": parseInt(SelectedDepo),
            "optn": parseInt(OptnValue),

        };


        const dataAPIResponse = await proxy(`/api/mis/nearexpiry`, payload, "get");

        if (dataAPIResponse && dataAPIResponse.data.length > 0) {
            setreportGenData(dataAPIResponse);
            setShowOptions(false);
            setShowProcessLoader(false);
        } else {
            alert('No data found');
        }



    }

    const handleBranchChange = async (newValue) => {
        setSelectedDepo(newValue);

    }

    const loadProductItems = async (division, year) => {
        setProductlistLoading(true);
        const payload = {};
        const dataAPIResponse = await proxy(`/api/mis/productlist/${division}/${year}/0`, payload, "get", true);
        setProductListItems(dataAPIResponse);
        setSelectedProductCode(dataAPIResponse.data[0].value);
        setProductlistLoading(false);

    }

    useEffect(() => {
        getSampleProducts(SelectedDiv);
        loadProductItems(SelectedDiv, SelectedYear);
        transformNavDataForLabels("HY04").then(title => {
            setPageTitle(title);
        });
    }, []);


    return (<> <div class="main-content">
        {showProcessLoader && <ProcessLoader />}

        {


            showOptions ?
                <ReportOptions title={pageTitle} >
                    <div className="report-option-wrapper">
                        <div className="report-option-row">
                            <div className="report-option-item">
                                <label>Division</label>
                                <DropDownControl selectedValue={SelectedDiv} data={div_data.data} id="report_div_list" name="report_div_list" onChange={(newVal) => { setSelectedDIV(newVal); loadProductItems(newVal, SelectedYear);getSampleProducts(newVal); }} />
                            </div>

                            <div className="report-option-item ml-20" >
                                <label>Branch</label>
                                <DropDownControl data={depo_data.data} id="report_branch_list" name="report_branch_list"

                                    onChange={handleBranchChange}
                                />
                            </div>

                        </div>
                        <div className="report-option-row">
                            <div className="report-option-item">
                                <input type="radio" class="js-switched mr-10" name="report_Optnvalue" checked={(true && OptnValue === 1)}
                                    onChange={(e) => { setOptnValue(1);; }} />
                                <label>Sales</label>
                            </div>
                            <div className="report-option-item ml-14">
                                <input type="radio" class="js-switched mr-10" name="report_Optnvalue" checked={(true && OptnValue === 2)}
                                    onChange={(e) => { setOptnValue(2); }} />
                                <label>Sample</label>
                            </div>



                        </div>



                        <div className="report-option-row">
                            <div className="report-option-item">
                                <label className="mr-16" >Product</label>
                                {productlistLoading ? <BrandedLoader /> : <DropDownControl data={OptnValue === 1 ? productListItems.data : sampleListItems.data}
 onChange={(newVal) => { setSelectedProductCode(newVal); }} />}
                            </div>

                        </div>


                        <div className="report-option-row">
                            <div className="report-option-item hide">
                                <label className="mr-16">Select&nbsp;Date</label>
                                <div class="input-group" data-provide="datepicker" data-orientation="bottom left" data-format="dd/mm/yyyy" >
                                    <input type="text" class="form-control" id="SelectedDate" value={SelectedDate} />
                                    <div class="input-group-append picker">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>
                                </div>
                            </div>

                            <div className="report-option-item">
                                <input type="radio" class="js-switched mr-10" name="report_branchhq" checked={(true && ReportType === 1)}
                                    onChange={(e) => { setReportType(1);; }} />
                                <label>Batchwise</label>
                            </div>
                            <div className="report-option-item ml-14">
                                <input type="radio" class="js-switched mr-10" name="report_branchhq" checked={(true && ReportType === 2)}
                                    onChange={(e) => { setReportType(2); }} />
                                <label>Summary</label>
                            </div>



                        </div>

                        <div className="report-option-action-row">
                            <button onClick={(e) => { navigate('/dashboard'); }} className="btn btn-outline btn-md btn-sec mr-10 fw-500">BACK</button>
                            <button onClick={handleReportGen} className="btn btn-md btn-primary pr-30 pl-30 fw-500 " id="btnReportGen" >SUBMIT</button>
                        </div>
                    </div></ReportOptions>


                :
                <div className="row">
                    <div className="col-12">
                        <div className="card report-card" style={{ width: "auto" }}>
                            <div className="card-title report-card-title">{reportGenData.title}
                                <button className="btn btn-outline btn-md  mr-10 fw-500" onClick={(e) => { window.location.reload() }}>BACK</button>
                            </div>
                            <div className="card-body">
                                <DynamicDTFloat
                                    tableData={reportGenData}
                                    handleExportSheet={handleExportSheet}
                                    firstColWidth="170px"
                                    secColWidth="120px"
                                    fixedColumns={true}
                                    forceDecimal={reportGenData.decimal_keys?.length > 0}
                                    decimalKeys={reportGenData.decimal_keys}
                                />


                            </div>

                        </div>
                    </div>
                </div>}
    </div>
    </>);
}



export default HY04;